export const SumtotalInvestEducation = (balanceData) => {
  let addBalance = balanceData?.property_invest_list
    ? balanceData?.property_invest_list
    : [];
  let sumForEducation = 0;

  addBalance?.map((row, index) => {
    {
      /*---------- พันธบัตร/หุ้นกู้ ----------*/
    }
    if (row?.options_property_invest === "property_invest_bond") {
      row?.invest_bond_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- หุ้นบุริมสิทธิ ----------*/

    if (row?.options_property_invest === "property_invest_preferred") {
      row?.invest_preferred_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- หุ้นสามัญ ----------*/
    if (row?.options_property_invest === "property_invest_normal") {
      row?.invest_normal_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมตลาดเงิน ----------*/
    if (row?.options_property_invest === "property_invest_market") {
      row?.invest_market_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมหุ้น ----------*/
    if (row?.options_property_invest === "property_all_invest") {
      row?.all_invest_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมเพื่อการเลี้ยงชีพ ----------*/
    if (row?.options_property_invest === "property_invest_life") {
      row?.invest_life_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมผสม ----------*/
    if (row?.options_property_invest === "property_invest_mixed") {
      row?.invest_mixed_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนสำรองเลี้ยงชีพ ----------*/
    if (row?.options_property_invest === "property_invest_provident_fund") {
      row?.invest_provident_fund_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- เงินออมเพื่อวัยเกษียณอื่น ๆ ----------*/
    if (
      row?.options_property_invest ===
      "property_invest_other_retirement_savings"
    ) {
      row?.invest_other_retirement_savings_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตลาดเงินอื่น ๆ ----------*/
    if (row?.options_property_invest === "property_money_market_other") {
      row?.invest_money_market_other_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารอนุพันธ์ ----------*/
    if (
      row?.options_property_invest === "property_invest_derivative_instruments"
    ) {
      row?.invest_derivative_instruments_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- มูลค่าเงินสดในกรมธรรม์ประกันชีวิต ----------*/
    if (
      row?.options_property_invest === "property_invest_life_insurance_policy"
    ) {
      row?.invest_life_insurance_policy_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- สลากออมสิน ----------*/
    if (row?.options_property_invest === "property_aomsin_bond_policy") {
      row?.aomsin_bond_policy_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารหนี้อื่นๆ ----------*/
    if (row?.options_property_invest === "property_debt_instruments") {
      row?.property_debt_instruments_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- อสังหาริมทรัพย์ ----------*/
    if (row?.options_property_invest === "property_invest_real_estate") {
      row?.invest_real_estate_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- มูลค่าทองคำ ----------*/
    if (row?.options_property_invest === "property_invest_gold_cost") {
      row?.invest_gold_cost_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- หุ้นในส่วนที่เป็นเจ้าของ ----------*/
    if (row?.options_property_invest === "property_invest_owner") {
      row?.invest_owner_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารทุนอื่นๆ ----------*/
    if (row?.options_property_invest === "property_equity_instruments") {
      row?.invest_equity_instruments_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- เงินลงทุนอื่น ๆ ----------*/
    if (row?.options_property_invest === "property_invest_other") {
      row?.invest_other_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารหนี้ภาครัฐ ----------*/
    if (row?.options_property_invest === "property_invest_goverment") {
      row?.invest_other_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารหนี้ภาคเอกชน ----------*/
    if (row?.options_property_invest === "property_invest_private") {
      row?.invest_private_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- เงินฝาก ----------*/
    if (row?.options_property_invest === "property_invest_deposit") {
        row?.invest_deposit_lists
          ?.sort((a, b) => new Date(b.created) - new Date(a.created))
          ?.map((row, indexCard) => {
            if (row?.target_invest?.value === "property_invest_education") {
              sumForEducation += row?.amount;
            }
          });
      }
   
  });

  return sumForEducation
};
